/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Item_NumberInputs */

const he_notifications_item_number = /** @type {(inputs: Notifications_Item_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצר #`)
};

const en_notifications_item_number = /** @type {(inputs: Notifications_Item_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product #`)
};

/**
* | output |
* | --- |
* | "Product #" |
*
* @param {Notifications_Item_NumberInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_item_number = /** @type {((inputs?: Notifications_Item_NumberInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Item_NumberInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_item_number(inputs)
	return en_notifications_item_number(inputs)
});